import { z } from 'zod'

export const ProviderFormSchema = z.object({
  expenseCategories: z
    .array(z.number())
    .min(1, 'At least one expense category must be selected.'),
  comments: z.string().optional(),
  invoiceNumber: z.string().optional(),
})

export const AddDetailsToOrderFormSchema = z.object({
  payment_amount: z.coerce.number().min(1, { message: 'payment_amount_is_required' }),
})

export type AddDetailsToOrderForm = z.infer<typeof AddDetailsToOrderFormSchema>
